import bus from './bus';

const types = {
  // Global
  TOGGLE_AUTH_PAGE: 'toggleAuthPage',
  ON_ROUTE_CHANGE: 'onRouteChange',
  UPDATE_LOCAL_USER: 'updateLocalUser',

  // Authentication
  SIGNUP_WITH_CREDS: 'createUserWithEmailAndPassword',
  LOGIN_WITH_CREDS: 'signInWithEmailAndPassword',
  LOGIN_WITH_GOOGLE: 'loginWithGoogle',
  LOGIN_WITH_GITHUB: 'loginWithGithub',
  LOGOUT: 'logout',

  // Snackbar
  CLOSE_SNACKBAR: 'closeSnackbar',
  SHOW_SNACKBAR: 'showSnackbar',

  // Global - Popups
  OPEN_GLOBAL_POPUP: 'openGlobalPopup',
  CLOSE_GLOBAL_POPUP: 'closeGlobalPopup',
  SAVE_GLOBAL_POPUP: 'saveGlobalPopup',

  // DB - User
  GET_CURRENT_USER: 'db/getDbUser',
  UPDATE_AUTH_USER: 'updateAuthUser',
  SYNC_USER: 'syncUser',
  UPDATE_AND_SYNC_USER: 'db/updateAndSyncUser',

  // DB - Types
  CREATE_PROJECT_TYPE: 'createProjectType',
  GET_PROJECT_TYPES: 'getProjectTypes',
  UPDATE_PROJECT_TYPE: 'updateProjectType',
  DELETE_PROJECT_TYPE: 'deleteProjectType',
  DELETE_ALL_PROJECT_TYPES: 'deleteAllProjectTypes',

  // DB - Stages
  CREATE_PROJECT_STAGE: 'createProjectStage',
  GET_PROJECT_STAGES: 'getProjectStages',
  UPDATE_PROJECT_STAGE: 'updateProjectStage',
  DELETE_PROJECT_STAGE: 'deleteProjectStage',
  DELETE_ALL_PROJECT_STAGES: 'deleteAllProjectStages',

  // DB - Feature
  CREATE_PROJECT_FEATURE: 'createProjectFeature',
  GET_PROJECT_FEATURES: 'getProjectFeatures',
  UPDATE_PROJECT_FEATURE: 'updateProjectFeature',
  DELETE_PROJECT_FEATURE: 'deleteProjectFeature',
  DELETE_ALL_PROJECT_FEATURES: 'deleteAllProjectFeatures',

  // DB - Plans or Groups
  CREATE_PROJECT_PLAN: 'createProjectPlan',
  GET_PROJECT_PLANS: 'getProjectPlans',
  UPDATE_PROJECT_PLAN: 'updateProjectPlan',
  DELETE_PROJECT_PLAN: 'deleteProjectPlan',
  DELETE_ALL_PROJECT_PLANS: 'deleteAllProjectPlans',

  // DB - Contacts
  CREATE_CONTACT: 'createContact',
  GET_CONTACTS: 'getContacts',
  UPDATE_CONTACT: 'updateContact',
  DELETE_CONTACT: 'deleteContact',
  DELETE_ALL_CONTACTS: 'deleteAllContacts',

  // DB - Projects
  CREATE_PROJECT: 'createProject',
  GET_PROJECT_BY_ID: 'getProjectById',
  UPDATE_PROJECT: 'updateProject',
  DELETE_PROJECT: 'deleteProject',
  GET_PROJECTS: 'getProjects',
  DELETE_ALL_PROJECTS: 'deleteAllProjects',

  // DB - Project Issues, Tasks, Bugs, Todos
  CREATE_ISSUE: 'createIssue',
  UPDATE_ISSUE: 'updateIssue',
  DELETE_ISSUE: 'deleteIssue',
  GET_ISSUES: 'getIssues',
  GET_ISSUE_BY_ID: 'getIssueById',

  // DB - Milestones
  // CREATE_MILESTONE: 'createMilestone',
  // GET_MILESTONES: 'getMilestones',
  // UPDATE_MILESTONE: 'updateMilestone',
  // DELETE_MILESTONE: 'deleteMilestone',
  // DELETE_ALL_MILESTONES: 'deleteAllMilestones',

  // DB - Estimates
  CREATE_ESTIMATE: 'createEstimate',
  GET_ESTIMATES: 'getEstimates',
  UPDATE_ESTIMATE: 'updateEstimate',
  DELETE_ESTIMATE: 'deleteEstimate',
  DELETE_ALL_ESTIMATES: 'deleteAllEstimates',

  // DB - Timesheets
  CREATE_TIMESHEET: 'createTimesheet',
  GET_TIMESHEETS: 'getTimesheets',
  UPDATE_TIMESHEET: 'updateTimesheet',
  DELETE_TIMESHEET: 'deleteTimesheet',
  DELETE_ALL_TIMESHEETS: 'deleteAllTimesheets',

  // DB - Expenses
  CREATE_EXPENSE: 'createExpense',
  GET_EXPENSES: 'getExpenses',
  UPDATE_EXPENSE: 'updateExpense',
  DELETE_EXPENSE: 'deleteExpense',
  DELETE_ALL_EXPENSES: 'deleteAllExpenses',

  // DB - Roles
  CREATE_ROLE: 'createRole',
  GET_ROLES: 'getRoles',
  UPDATE_ROLE: 'updateRole',
  DELETE_ROLE: 'deleteRole',
  DELETE_ALL_ROLES: 'deleteAllRoles',

  // DB - Users
  CREATE_USER: 'createUser',
  GET_USERS: 'getUsers',
  UPDATE_USER: 'updateUser',
  DELETE_USER: 'deleteUser',
  DELETE_ALL_USERS: 'deleteAllUsers',

  // DB - Statistics
  GET_STATS: 'getStats',
  GET_DASHBOARD_STATS: 'getDashboardStats',
};

export const BUS = bus;

export default types;
